import React, { useEffect, useState } from 'react';
import { Form, Input, Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import '../SurveyAnswer.less';
import { uploadFileApi } from '../../api';
import config from '../../../../config';

// 问答题
const Answer: React.FC = ({ body, id, required, attachment, num, form }: { body?: string; required?: boolean; num?: number; id?: number; attachment?: string[]; form?: any }) => {
    const [fileList, setFileList] = useState<any>([]);

    // 移除图片
    const onRemove = (value: any) => {
        const newFileList = fileList.filter((file: any) => file.url !== value.url);
        setFileList(newFileList);
    };

    // 上传头像
    const upload = async (value: any) => {
        let data = new Date();
        const formData = new FormData();
        formData.append('file', value.file);
        formData.append('path', `attachments/${data.getFullYear()}${data.getMonth() + 1}/`);
        const res: any = await uploadFileApi(formData);
        if (res && res.status_code === 200) {
            const list = fileList.concat([{ url: `${config.OSS_URL_PREFIX}/${res.data}` }]);
            let formData = form.getFieldsValue();
            formData[`${id}-6`].file.fileList = list;
            localStorage.setItem('formData', JSON.stringify(formData));
            setFileList(list);
        }
    };
    // 上传头像格式校验
    const beforeUpload = (file: any) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        if (!isJpgOrPng) {
            message.error('只能上传 jpg/png/jpeg 格式');
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('图片大小不超过5MB');
        }
        return isJpgOrPng && isLt5M;
    };

    useEffect(() => {
        const formData = localStorage.getItem('initFormData');
        if (formData) {
            let arr = JSON.parse(formData);
            if (arr[`${id}-6`]?.file?.fileList) {
                setFileList(arr[`${id}-6`]?.file?.fileList);
            }
        }

        if (attachment && attachment.length) {
            const arr = attachment.map((it: string) => ({ url: it }));
            setFileList(arr);
        }
    }, [attachment]);

    return (
        <>
            <Form.Item name={`${id}-6`} rules={[{ required, message: '该题为必答题，请作答后提交。' }]} label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}>
                <Form.Item name={[`${id}-6`, 'text']} rules={[{ required, message: '' }]} label="">
                    <Input.TextArea rows={4} className="text-area" autoComplete="off" maxLength={2000} showCount />
                </Form.Item>
                <Form.Item label="" name={[`${id}-6`, 'file']} style={{ display: 'none' }}>
                    <Upload customRequest={upload} listType="picture-card" fileList={fileList} onRemove={onRemove} beforeUpload={beforeUpload}>
                        {fileList.length > 10 ? null : (
                            <div>
                                <PlusOutlined />
                                <div
                                    style={{
                                        marginTop: 8,
                                    }}
                                >
                                    上传图片
                                </div>
                            </div>
                        )}
                    </Upload>
                </Form.Item>
            </Form.Item>
        </>
    );
};

export default Answer;
